var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.55 7C12.55 10.0652 10.0652 12.55 7 12.55V13.45C10.5622 13.45 13.45 10.5622 13.45 7H12.55ZM7 12.55C3.93482 12.55 1.45 10.0652 1.45 7H0.55C0.55 10.5622 3.43776 13.45 7 13.45V12.55ZM1.45 7C1.45 3.93482 3.93482 1.45 7 1.45V0.55C3.43776 0.55 0.55 3.43776 0.55 7H1.45ZM7 1.45C10.0652 1.45 12.55 3.93482 12.55 7H13.45C13.45 3.43776 10.5622 0.55 7 0.55V1.45Z",
    fill: "#555555"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7 9.4V7",
    stroke: "#555555",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7 4.60156V4.75156",
    stroke: "#555555",
    strokeWidth: 1.2,
    strokeLinecap: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIIcon);
export default __webpack_public_path__ + "static/media/iIcon.45ff90ac06ba1b6557130d599084b04a.svg";
export { ForwardRef as ReactComponent };